/*
 * ff-sticky-atc.js — mobile sticky Add to cart bar (product pages only; no dependencies).
 * The bar is purely a shortcut: it clicks the real #ProductSubmitButton-<section>, so product-form.js handles everything.
 * It stays hidden while the main Add to cart button, the Make an Offer button or its inline form are on screen.
 */
(function () {
  var bar = document.querySelector('.ff-sticky-atc');
  if (!bar || !('IntersectionObserver' in window)) return;
  var mq = window.matchMedia('(max-width: 749px)');
  var submit = document.getElementById(bar.dataset.submitId);
  var priceSrc = document.getElementById(bar.dataset.priceId);
  var btn = bar.querySelector('[data-ff-sticky-submit]');
  var errBox = bar.querySelector('.ff-sticky-atc__error');
  var priceDst = bar.querySelector('.ff-sticky-atc__price');
  if (!submit || !btn) return;

  var root = document.documentElement;
  var watched = new Map(); // element -> isIntersecting
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { watched.set(e.target, e.isIntersecting); });
    update();
  }, { threshold: 0 });

  function watch(el) { if (el && !watched.has(el)) { watched.set(el, false); io.observe(el); } }
  function scan() {
    watch(submit);
    document.querySelectorAll('make-an-offer-inline-form, make-an-offer-button, #mao-product-offer-modal, .shopify-app-block[id*="make_an_offer"]').forEach(watch);
  }

  function soldOut() { return submit.disabled || submit.hasAttribute('disabled') || submit.getAttribute('aria-disabled') === 'true' && /sold/i.test(submit.textContent); }

  function update() {
    var anyOnScreen = false;
    watched.forEach(function (v, el) { if (v && el.isConnected) anyOnScreen = true; });
    var show = mq.matches && !anyOnScreen && !soldOut();
    if (show === !bar.hidden) return;
    bar.hidden = !show;
    root.classList.toggle('ff-sticky-on', show);
    if (show) {
      root.style.setProperty('--ff-sticky-h', bar.offsetHeight + 'px');
      requestAnimationFrame(function () { bar.classList.add('is-visible'); });
    } else {
      bar.classList.remove('is-visible');
    }
  }

  // the offer app injects its elements after load; rescan a few times
  scan();
  [500, 1500, 3500].forEach(function (t) { setTimeout(function () { scan(); }, t); });
  new MutationObserver(function () { scan(); }).observe(document.body, { childList: true, subtree: true });
  mq.addEventListener ? mq.addEventListener('change', update) : mq.addListener(update);

  // keep the bar's price in sync when a variant change re-renders the main price (text is copied from the main price, never computed)
  if (priceSrc && priceDst) {
    var amount = priceDst.querySelector('[data-ff-amount]');
    var compare = priceDst.querySelector('[data-ff-compare]');
    var syncPrice = function () {
      var src = document.getElementById(bar.dataset.priceId);
      var p = src && src.querySelector('.price');
      if (!p || !amount) return;
      var onSale = p.classList.contains('price--on-sale');
      var cur = p.querySelector(onSale ? '.price-item--sale' : '.price__regular .price-item--regular');
      var was = p.querySelector('.price__sale .price-item--regular');
      if (cur) amount.textContent = cur.textContent.trim();
      if (compare) {
        compare.hidden = !(onSale && was);
        var s = compare.querySelector('s');
        if (s && was) s.textContent = was.textContent.trim();
      }
    };
    new MutationObserver(syncPrice).observe(priceSrc.parentNode, { childList: true, subtree: true, characterData: true });
  }
  // sold-out / unavailable variant -> hide the bar
  new MutationObserver(update).observe(submit, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });

  btn.addEventListener('click', function () {
    if (soldOut()) return;
    errBox.hidden = true;
    submit.click();
  });

  // mirror the main form's error message (e.g. "all items already in cart") because the real one is off screen
  var errSrc = document.querySelector('.product-form__error-message-wrapper');
  if (errSrc && errBox) {
    new MutationObserver(function () {
      var m = errSrc.querySelector('.product-form__error-message');
      var show = !errSrc.hasAttribute('hidden') && m && m.textContent.trim();
      errBox.textContent = show ? m.textContent.trim() : '';
      errBox.hidden = !show;
    }).observe(errSrc, { attributes: true, childList: true, subtree: true, characterData: true });
  }
})();
